import Email from "@pages/auth/schema/Email";

import Password from "@src/schema/Password";

import { INPUT } from "@utils/constant";

export const { EMAIL, LOGIN_PASSWORD } = INPUT.NAME;

const CredentialsSchema = Email.concat(Password);
export const LoginSchema = CredentialsSchema.pick([EMAIL, LOGIN_PASSWORD]);
